module.exports = __webpack_public_path__ + "img/sdg11.bf8bff6a.svg";